module.exports = __webpack_public_path__ + "static/media/pg.5c17391e.svg";